import TileLayerCanvas from "../../app/TileLayerCanvas";
import render from "../../app/render";
import store from "../../app/store";
import scope from "../../app/rootScope";
import utils from "../../app/utils";
import loader from "../../app/dataLoader";
import test from "../../app/performanceTest";
import products from "../../app/products";
import broadcast from "../../app/broadcast";
import lrucache from "../../app/lruCache";

const productRadar=products.radar;

var cache = new lrucache(50);

export default TileLayerCanvas.extend(
    {
        onAdd: function(map) {
            render.emit("updateBasemap", {coverWholeMap: false, hasSea: false});

            L.GridLayer.prototype.onAdd.call(this, map),
                map.on("movestart", this.onMoveStart, this),
                map.on("moveend", this.onMoveEnd, this),
                this.on("load", this.checkLoaded, this);
        },

        _update: function (center) {
            L.GridLayer.prototype._update.call(this, center);
        },

        onMoveStart: function() {

            TileLayerCanvas.prototype.onMoveStart.call(this)
            broadcast.emit("SatLayerMoveStart");
        },
        onMoveEnd: function() {
            TileLayerCanvas.prototype.onMoveEnd.call(this)
            broadcast.emit("SatLayerMoveStop");
        },

        // Cuando se cambian los parámetros
        timestampChanged: function(timestamp) {
            const radarCalendar = store.get("radarCalendar");
            const params =  {

                server: this.server || productRadar.server || scope.server,
                directory: productRadar.directory,
                filename: "radar",
                fileSuffix:  productRadar.fileSuffix,
                path: radarCalendar.ts2path(timestamp),
                nextpath: radarCalendar.ts2nextpath(timestamp),
                maxTileZoom: productRadar.maxTileZoom

            };


            this.latestParams.fullPath = utils.template(productRadar.pathGenerator, params);
            const nextPathGenerator = productRadar.pathGenerator.replace(/\{\{?\s*(path)\s*\}?\}/g, "{nextpath}");
            this.latestParams.fullNextPath = utils.template(nextPathGenerator, params);

            this.syncCounter++;
            this.redrawLayer(timestamp);

        },

        redrawLayer: function(timestamp) {
            var map = this._map
                , bounds = map.getPixelBounds()
                , TLPoint = bounds.min
                , BRPoint = bounds.max
                , TLcoords = TLPoint.divideBy(256)._floor()
                , BRcoords = BRPoint.divideBy(256)._floor()
                , boundTiles = L.bounds(TLcoords, BRcoords)
                , zoom = Math.round(map.getZoom());

            // console.info("redrawlayer");

            if (zoom > 11)
                this.redrawFinished();
            else {
                this.removeOtherTiles(zoom, boundTiles);
                var coords = this.sortTilesFromCenterOut(boundTiles);
                this._tilesToLoad = coords.length;
                for (var i = 0; i < coords.length; i++) {
                    var coordTile = coords[i]
                        , key = this._tileCoordsToKey(coordTile);
                    if(key in this._tiles)
                        this.redrawTile(this._tiles[key], timestamp)
                    else
                        --this._tilesToLoad || this.redrawFinished()   // Si llega a 0 llama a redrawFinished
                }
            }
        },

        // Crea una tesela
        createTile: function(coords, done) {
            var timestamp = coords.timestamp;
            var layercanvas = this;
            coords = this._wrapCoords(coords);
            coords.timestamp = timestamp;

            var url = this.getTileUrl(coords);
            // console.info("createTile");

            // let params = this.latestParams;
            //
            // if (coords.timestamp){
            //     params = utils.clone(this.latestParams);
            //
            // }

            var whichTile = render.whichTile(coords, this.latestParams)   // Obtenemos coordenadas de tesela de datos
                , canvas = L.DomUtil.create("canvas")                     // Se crea el canvas sobre el que se va a pintar
                , syncCounter = this.syncCounter;

            whichTile.s = this._getSubdomain(coords);

            canvas.width = canvas.height = scope.isRetina ? 512 : 256;
            canvas.coords = coords;
            // canvas.url = this.latestParams.fullPath.replace("<z>", coords.z).replace("<y>", coords.y).replace("<x>", coords.x)

            loader.loadTile(whichTile).then(function(loader) {

                    canvas.style.width = canvas.style.height = "256px";
                    layercanvas.renderTile.call(layercanvas, test.getPerformance() === "low" ? 2 : 1, canvas, syncCounter, whichTile, loader, url); // Con la tesela de datos cargada se renderiza la de colores

                    done(void 0, canvas);
                }
            ).catch(console.error);

            return canvas   // Se devuelve la tesela renderizada
        },

        // redrawLayer: function() {
        //     var map = this._map
        //         , bounds = map.getPixelBounds()
        //         , TLPoint = bounds.min
        //         , BRPoint = bounds.max
        //         , TLcoords = TLPoint.divideBy(256)._floor()
        //         , BRcoords = BRPoint.divideBy(256)._floor()
        //         , boundTiles = L.bounds(TLcoords, BRcoords)
        //         , zoom = Math.round(map.getZoom());
        //
        //     // console.info("redrawlayer");
        //
        //     if (zoom > 11)
        //         this.redrawFinished();
        //     else {
        //         this.removeOtherTiles(zoom, boundTiles);
        //         var coords = this.sortTilesFromCenterOut(boundTiles);
        //         this._tilesToLoad = coords.length;
        //         for (var i = 0; i < coords.length; i++) {
        //             var coordTile = coords[i]
        //                 , key = this._tileCoordsToKey(coordTile);
        //             if(key in this._tiles)
        //                 this.redrawTile(this._tiles[key])
        //             else
        //                 --this._tilesToLoad || this.redrawFinished()   // Si llega a 0 llama a redrawFinished
        //         }
        //     }
        // },

        // Repinta la tesela
        redrawTile: function(tile, timestamp) {
            var layercanvas = this;
            tile.coords = this._wrapCoords(tile.coords);
            var url = this.getTileUrl(tile.coords);
            const key = `${timestamp}_${tile.coords.x}_${tile.coords.y}_${tile.coords.z}`
            var whichTile = render.whichTile(tile.coords, this.latestParams)
                , syncCounter = this.syncCounter;



            let cachedCanvas = cache.get(key);

            if (cachedCanvas){
                const ctx = tile.el.getContext('2d');

                ctx.fillRect(0, 0, tile.el.width, tile.el.height);
                ctx.clearRect(0, 0, tile.el.width, tile.el.height);
                ctx.drawImage(cachedCanvas,0,0,cachedCanvas.width,cachedCanvas.height);

                if ( --layercanvas._tilesToLoad === 0)
                    layercanvas.redrawFinished();
            }
            else {

                whichTile.s = this._getSubdomain(tile.coords);

                loader.loadTile(whichTile).then(function (loader) {
                    layercanvas.renderTile.call(layercanvas, test.getPerformance() === "low" ? 2 : 1, tile.el, syncCounter, whichTile, loader, url);

                    if (--layercanvas._tilesToLoad === 0)
                        layercanvas.redrawFinished();

                }).catch(console.error)
            }
        },

        preload: function (timestamp, step) {
            let map = this._map
                , bounds = map.getPixelBounds()
                , TLPoint = bounds.min
                , BRPoint = bounds.max
                , TLcoords = TLPoint.divideBy(256)._floor()
                , BRcoords = BRPoint.divideBy(256)._floor()
                , boundTiles = L.bounds(TLcoords, BRcoords)
                , boundTilesData
                , zoom = Math.round(map.getZoom())
                // , ntiles
                , ntiles = (boundTiles.max.x - boundTiles.min.x + 1) * (boundTiles.max.y - boundTiles.min.y + 1)
            ;
            // boundTiles.min.z = zoom;
            // boundTiles.max.z = zoom;
            //
            // boundTilesData = {min: render.whichTile(boundTiles.min, this.latestParams),  max: render.whichTile(boundTiles.max, this.latestParams)}
            // ntiles = (boundTilesData.max.x - boundTilesData.min.x + 1) * (boundTilesData.max.y - boundTilesData.min.y + 1);

            const radarCalendar = store.get("radarCalendar");

            if (typeof step === "undefined")
                step = radarCalendar.step * 1000;
            // Cuando el step es mayor que 300 es necesario que la caché sea más grande
            const mul = step / radarCalendar.step * 1000;

            const nframes = (radarCalendar.end - timestamp) / step + 1;
            let tilestoload = ntiles * nframes;
            const syncCounter = this.syncCounter;

            cache = new lrucache(tilestoload * mul);

            const radarLayer = this;
            const params =  {

                server: this.server || productRadar.server || scope.server,
                directory: productRadar.directory,
                filename: "radar",
                fileSuffix:  productRadar.fileSuffix,
                // path: radarCalendar.ts2path(ts),
                // nextpath: radarCalendar.ts2nextpath(ts),
                maxTileZoom: productRadar.maxTileZoom

            };



            // let whichTile = utils.clone (boundTilesData.min);

            var y, x, nf, url;
            for (nf = 0; nf < nframes; nf++) {
                // console.info(new Date(timestamp));
                params.path = radarCalendar.ts2path(timestamp);
                this.latestParams.fullPath = utils.template(productRadar.pathGenerator, params);
                // console.info ("fullPath: "+ fullPath);

                for (y = boundTiles.min.y; y <= boundTiles.max.y; y++)
                    for (x = boundTiles.min.x; x <= boundTiles.max.x; x++) {

                        this.createTile({x: x, y: y, z: zoom, timestamp: timestamp},
                            function(bool, canvas){
                                const key = `${canvas.coords.timestamp}_${canvas.coords.x}_${canvas.coords.y}_${canvas.coords.z}`
                                const cachedCanvas = cache.get(key);

                                if (!cachedCanvas) {
                                    cache.put(key, canvas);

                                    if (radarLayer.syncCounter === syncCounter) {
                                        if (--tilestoload === 0) {
                                            // console.info("Se cargaron todas las teselas")
                                            broadcast.emit("preloadedtiles", "complete")
                                        } else {
                                            broadcast.emit("preloadedtiles", Math.round((1 - tilestoload / (ntiles * nframes)) * 100))
                                        }
                                    }
                                }
                            }
                        )

                        // whichTile.x = x;
                        // whichTile.y = y;
                        //
                        // whichTile.url = utils.template(fullPath.replace("<z>", zoom.toString()).replace("<y>", y).replace("<x>", x), {s: this._getSubdomain({x: x, y: y})});
                        // console.info(whichTile.url);
                        // whichTile.nextUrl = null;
                        //
                        // loader.loadTile(whichTile).then(
                        //     (loader) => {
                        //         if (radarLayer.syncCounter === syncCounter) {
                        //             if (--tilestoload === 0) {
                        //                 // console.info("Se cargaron todas las teselas")
                        //                 broadcast.emit("preloadedtiles", "complete")
                        //             } else {
                        //                 broadcast.emit("preloadedtiles", Math.round((1 - tilestoload / (ntiles * nframes)) * 100))
                        //             }
                        //
                        //         }
                        //     }
                        // );

                    }
                timestamp = radarCalendar.bestTs(timestamp + step);

            }

        },

        init: function() {
            // this.latestParams = utils.clone(params);

            const radarCalendar = store.get("radarCalendar");
            const ts = store.get("radarTimestamp");


            const nextPathGenerator = productRadar.pathGenerator.replace(/\{\{?\s*(path)\s*\}?\}/g, "{nextpath}");

            const params =  {

                server: this.server || productRadar.server || scope.server,
                directory: productRadar.directory,
                filename: "radar",
                fileSuffix:  productRadar.fileSuffix,
                path: radarCalendar.ts2path(ts),
                nextpath: radarCalendar.ts2nextpath(ts),
                maxTileZoom: productRadar.maxTileZoom

            };
            //
            this.latestParams = {
                fullPath : utils.template(productRadar.pathGenerator, params),
                fullNextPath : utils.template(nextPathGenerator, params),
                dataQuality : "top",
                maxTileZoom : productRadar.maxTileZoom,
                layer: "radar",
                PNGtransparency: true,
                fileSuffix: "png"

            }

        },

    }
);
